export const formFields = [
  {
    key: 'name',
    label: 'Product',
    type: 'text',
    isRequired: true,
  },
  {
    key: 'revenue',
    label: 'Revenue',
    type: 'money',
    isRequired: true,
  },
  {
    key: 'costOfSales',
    label: 'Cost of Sales',
    type: 'money',
    isRequired: true,
  },
];
